module.exports = __webpack_public_path__ + "static/media/github.d177840a.svg";